export enum SessionStatus {

  APP_DATA = 'APP_DATA',
  CONNECTED = 'CONNECTED',
  DEBUG = 'DEBUG',
  DISCONNECTED = 'DISCONNECTED',
  ESTABLISHED = 'ESTABLISHED',
  FAILED = 'FAILED',
  SEND_DATA_STATUS = 'SEND_DATA_STATUS',
  WARN = 'WARN'

}
